var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: "45",
        height: "45",
        viewBox: "0 0 45 45",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_37_11253)" } }, [
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M28.4656 8.93894L20.7994 42.1449L19.5565 41.8579L27.2227 8.65201L28.4656 8.93894Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M6.20538 22.0968L40.2901 29.9659L40.5771 28.723L6.49232 20.8539L6.20538 22.0968Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M23.3664 12.8013L32.1024 16.0675L35.9701 24.5544L32.7039 33.2904L24.217 37.1581L15.481 33.8919L11.6133 25.405L14.8795 16.669L23.3664 12.8013Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M14.7838 18.8445L12.8796 27.0802L17.3566 34.2503L25.5924 36.1545L32.7624 31.6774L34.6666 23.4417L30.1896 16.2716L21.9538 14.3674L14.7838 18.8445ZM21.499 11.6438L12.5363 17.2403L10.156 27.5351L15.7524 36.4978L26.0472 38.8781L35.0099 33.2817L37.3902 22.9868L31.7938 14.0241L21.499 11.6438Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M6.05176 27.1885L8.49073 16.6241L10.9765 17.198L8.53749 27.7624L6.05176 27.1885Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M4.13979 24.1285L5.43102 18.5356L8.49062 16.6238L6.05165 27.1881L4.13979 24.1285Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M33.1709 10.2422L22.6065 7.80321L22.0327 10.2889L32.597 12.7279L33.1709 10.2422Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            d:
              "M31.2594 7.18198L25.6665 5.89076L22.6069 7.80262L33.1712 10.2416L31.2594 7.18198Z",
            fill: "#E1503C"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M19.8522 20.1822L18.5003 18.0187L19.582 17.3428L20.9339 19.5062L19.8522 20.1822Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M16.4723 14.773L15.1204 12.6095L16.2021 11.9336L17.554 14.0971L16.4723 14.773Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M13.9038 11.8659L16.0672 10.514L16.7432 11.5957L14.5797 12.9476L13.9038 11.8659Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M27.9635 33.1627L26.6116 30.9992L27.6934 30.3232L29.0452 32.4867L27.9635 33.1627Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M28.8437 21.3327L31.0072 19.9808L31.6831 21.0625L29.5196 22.4144L28.8437 21.3327Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M15.8627 29.444L18.0262 28.0921L18.7021 29.1738L16.5387 30.5257L15.8627 29.444Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M24.4536 25.1392L26.1188 17.9265L24.8759 17.6396L23.0919 25.3671L25.5977 29.3772L26.6794 28.7013L24.4536 25.1392Z",
            fill: "black"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M8.2236 24.4404L5.58709 23.8317L5.87402 22.5889L8.51054 23.1976L8.2236 24.4404Z",
            fill: "white"
          }
        }),
        _vm._v(" "),
        _c("path", {
          attrs: {
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d:
              "M25.8515 10.234L26.4602 7.59748L25.2173 7.31055L24.6086 9.94706L25.8515 10.234Z",
            fill: "white"
          }
        })
      ]),
      _vm._v(" "),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_37_11253" } }, [
          _c("rect", {
            attrs: {
              width: "32",
              height: "32",
              fill: "white",
              transform: "translate(0 17.4092) rotate(-32)"
            }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }